// Phase 10f-1b — operator dispute admin read schemas (list + detail).
// Stripe/homecare-only by construction (facility AR has no "dispute"
// concept; corrections go through regenerate / void / record-payment /
// credit-memo paths). Read-only — no write surface. Inbound disputes
// arrive via the 10d-i-c Stripe webhook.
import { z } from 'zod';
import { InvoiceStatusSchema } from './enums.schema.js';
/** Stripe's dispute status values (mirror of Stripe.Dispute.Status). */
export const StripeDisputeStatusSchema = z.enum([
    'warning_needs_response',
    'warning_under_review',
    'warning_closed',
    'needs_response',
    'under_review',
    'charge_refunded',
    'won',
    'lost',
]);
export const DisputeListQuerySchema = z.object({
    status: StripeDisputeStatusSchema.optional(),
    fromDate: z.string().date().optional(),
    toDate: z.string().date().optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const DisputeListItemSchema = z.object({
    /** Latest PaymentEvent.id for this dispute (the "current state" row). */
    id: z.string().uuid(),
    stripeDisputeId: z.string(),
    currentStatus: z.string(),
    partyName: z.string(),
    invoiceId: z.string().uuid().nullable(),
    invoiceNumber: z.string().nullable(),
    disputedAmountCents: z.number().int().nonnegative(),
    reason: z.string().nullable(),
    openedAt: z.string().datetime(),
    closedAt: z.string().datetime().nullable(),
    finalOutcome: z.enum(['won', 'lost', 'warning_closed']).nullable(),
    unlinked: z.boolean(),
});
export const DisputeListResponseSchema = z.object({
    items: z.array(DisputeListItemSchema),
    page: z.number().int().min(1),
    limit: z.number().int().min(1),
    totalCount: z.number().int().min(0),
});
const InvoiceSummarySchema = z.object({
    id: z.string().uuid(),
    invoiceNumber: z.string().nullable(),
    status: InvoiceStatusSchema,
    totalCents: z.number().int().nonnegative(),
    amountPaidCents: z.number().int(),
});
const DisputeEventSchema = z.object({
    id: z.string().uuid(),
    status: z.string(),
    amountCents: z.number().int(),
    recordedAt: z.string().datetime(),
});
const OriginatingCaptureSchema = z.object({
    id: z.string().uuid(),
    amountCents: z.number().int().nonnegative(),
    externalRef: z.string().nullable(),
    recordedAt: z.string().datetime(),
});
const AuditEventSummarySchema = z.object({
    id: z.string().uuid(),
    action: z.string(),
    actorUserId: z.string().uuid().nullable(),
    createdAt: z.string().datetime(),
});
export const DisputeDetailResponseSchema = z.object({
    dispute: DisputeListItemSchema,
    /** Full chain (open + close events) ordered by recordedAt ASC. */
    disputeChain: z.array(DisputeEventSchema),
    originatingCapture: OriginatingCaptureSchema.nullable(),
    invoice: InvoiceSummarySchema.nullable(),
    /** Pre-rendered URL to Stripe Dashboard for this dispute. Operator's
     * one-click route to evidence upload / accept. */
    stripeDashboardUrl: z.string().url(),
    auditTrail: z.array(AuditEventSummarySchema),
});
//# sourceMappingURL=dispute-admin.schema.js.map